import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const PrestadorReducer = createReducer(INITIAL_STATE, (builder) => {
  /**
   * Obtener los procedimientos permitidos de un pss
   */
  builder
    .addCase(Types.GET_PROCEDIMIENTOS_PSS_LOADING, (state) => {
      state.getProcedimientosPssLoading = true;
      state.getProcedimientosPssError = null;
    })
    .addCase(Types.GET_PROCEDIMIENTOS_PSS_SUCCESS, (state, action) => {
      const { getProcedimientosPssData } = action;
      state.getProcedimientosPssData = getProcedimientosPssData;
      state.getProcedimientosPssLoading = false;
      state.getProcedimientosPssError = null;
    })
    .addCase(Types.GET_PROCEDIMIENTOS_PSS_FAILURE, (state, action) => {
      const { getProcedimientosPssError } = action;
      state.getProcedimientosPssData = INITIAL_STATE.getProcedimientosPssData;
      state.getProcedimientosPssLoading = false;
      state.getProcedimientosPssError = getProcedimientosPssError;
    });

  /**
   * Obtener listado de medicos por nombre o por código
   */
  builder
    .addCase(Types.GET_MEDICOS_LOADING, (state) => {
      state.getMedicosLoading = true;
      state.getMedicosError = null;
    })
    .addCase(Types.GET_MEDICOS_SUCCESS, (state, action) => {
      const { getMedicosData } = action;
      state.getMedicosData = getMedicosData;
      state.getMedicosLoading = false;
      state.getMedicosError = null;
    })
    .addCase(Types.GET_MEDICOS_FAILURE, (state, action) => {
      const { getMedicosError } = action;
      state.getMedicosData = INITIAL_STATE.getMedicosData;
      state.getMedicosLoading = false;
      state.getMedicosError = getMedicosError;
    });
});